import React from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";
import { useTranslation } from "react-i18next";
import { Modal } from "@lib/modal";
import { Button } from "@components/buttons";
import { MobilePlatform } from "@state/stores/types";
import { isCapacitorPlatform } from "@utils/specific/capacitor";
import { useFixBody } from "@state/hooks/shared";

export default observer(function BankIdFlowSelectPopup() {
	const { bankIdCapacitorStore } = useRootAppStore<MobilePlatform>();

	const { t } = useTranslation("login");

	if (!isCapacitorPlatform()) {
		return null;
	}

	useFixBody(true, bankIdCapacitorStore.isBankIdFlowPopupActive);

	return (
		<Modal>
			<div id="reuse-form" className="popup">
				<div className="popup__card">
					<div className="popup__header">
						<p className="popup__title">
							{t("BANK_ID.SELECT_OPTION")}
						</p>
						<button
							type="button"
							className="popup__close btn btn--square btn--square--sml btn--primary--inverted"
							title={t("COMMON.CLOSE")}
							onClick={() =>
								bankIdCapacitorStore.deactivateFlowPopup()
							}
						>
							<i className="u-icon u-icon--tny u-icon--close u-color--text--secondary" />
						</button>
					</div>
					<div className="popup__footer">
						<Button
							className="popup__btn popup__btn--secondary btn btn--base btn--block btn--primary--inverted"
							type="button"
							onClick={async () => {
								await bankIdCapacitorStore.runSameDeviceFlow();
							}}
							btnText={t("BANK_ID.SAME_DEVICE")}
						/>
						<Button
							className="popup__btn popup__btn--secondary btn btn--base btn--block btn--primary--inverted"
							type="button"
							onClick={async () => {
								await bankIdCapacitorStore.runDifferentDeviceFlow();
							}}
							btnText={t("BANK_ID.OTHER_DEVICE")}
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
});
